import { ReactNode } from 'react';

const ContentItem: React.FC<ContentItemProps> = ({ children, label, className = '' }) => (
    <div className={`content-item ${className}`}>
        <label>{label && label}</label>
        {children}
    </div>
);

interface ContentItemProps {
    children?: ReactNode;
    label?: ReactNode;
    className?: string;
}

export default ContentItem;
